import { render, staticRenderFns } from "./PdfViewerTools.vue?vue&type=template&id=08533ef0&"
import script from "./PdfViewerTools.vue?vue&type=script&lang=ts&"
export * from "./PdfViewerTools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports